import { Directive, ElementRef, Input } from '@angular/core';
@Directive({
  standalone: true,
  selector: '[colorIcon]',
})
export class ColorIconDirective {
  @Input() colorIcon: string;
  constructor(private el: ElementRef) {
    this.colorIcon = "#000000";
  }
  ngOnChanges() {
    this.el.nativeElement.style.backgroundColor = this.colorIcon;
  }
}
